import React, { Fragment } from 'react'
import md5 from 'md5'
import toBuffer from 'typedarray-to-buffer'
import decode from 'jwt-decode'

import { makeStyles } from '@material-ui/styles'
import AddIcon from '@material-ui/icons/Add'
import Fab from '@material-ui/core/Fab'

import classNames from 'classnames'
import CircularProgress from '@material-ui/core/CircularProgress'
import green from '@material-ui/core/colors/green'
import CheckIcon from '@material-ui/icons/Check'

import useFirebase from '../../useFirebase'
import GridView from './GridView'

function readAsArrayBuffer(file) {
  return new Promise(function(resolve) {
    var reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onload = function(e) {
      const buff = toBuffer(e.target.result)
      resolve(buff)
    }
  })
}

const MainView = ({ history }) => {
  const classes = useStyles()

  const firebase = useFirebase()
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  function onChange(e) {
    setLoading(true)
    const [file] = e.target.files
    // console.log(file)
    if (!file) return
    readAsArrayBuffer(file).then(buffer => {
      // console.log(buffer)
      const now = performance.now()
      const hash = md5(buffer)
      const after = performance.now() - now
      console.log(`
        file: ${file.name}
        size: ${file.size} bytes
        type: ${file.type}
        md5: ${hash}
        duration: ${after.toFixed(2)} ms 
      `)

      const storage = firebase.storage()
      const user = decode(window.token)
      const path = `orgs/${user.org}/docs/${hash}.pdf`
      const ref = storage.ref(path)
      console.log(ref)
      ref.put(file).then(snapshot => {
        setLoading(false)
        setSuccess(true)
        setTimeout(() => {
          history.push(`documents/${hash}`)
        }, 2000)
      })
    })
  }

  const buttonClassname = classNames({
    [classes.buttonSuccess]: success
  })

  return (
    <Fragment>
      <GridView />
      <div className={classes.wrapper}>
        <input
          type="file"
          accept="application/pdf"
          id="icon-button-file"
          className={classes.input}
          onChange={onChange}
        />
        <label htmlFor="icon-button-file">
          <Fab
            color="primary"
            aria-label="Add"
            className={buttonClassname}
            component="span">
            {success ? <CheckIcon /> : <AddIcon />}
          </Fab>
          {loading && (
            <CircularProgress size={68} className={classes.fabProgress} />
          )}
        </label>
      </div>
    </Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'fixed',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    }
  },

  input: {
    display: 'none'
  }
}))

export default MainView
